import { useState, useEffect } from "react";
import { X, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NewsletterForm } from "./NewsletterForm";
import { BRAND } from "@/config/brand";

const POPUP_STORAGE_KEY = "newsletter_popup_shown";
const POPUP_DELAY_MS = 30000; // 30 secondes

export const NewsletterPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Vérifier si la popup a déjà été affichée
    const hasShown = localStorage.getItem(POPUP_STORAGE_KEY);
    if (hasShown) return;

    // Afficher après le délai
    const timer = setTimeout(() => {
      setIsVisible(true);
      localStorage.setItem(POPUP_STORAGE_KEY, "true");
    }, POPUP_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-50 animate-fade-in"
        onClick={handleClose}
        aria-hidden="true"
      />

      {/* Popup - positionnée en bas à droite sur desktop, centrée sur mobile */}
      <div
        className="fixed z-50 
          bottom-4 right-4 left-4 sm:left-auto sm:w-[420px]
          bg-card rounded-xl shadow-2xl border border-border
          animate-slide-up overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="newsletter-popup-title"
      >
        {/* Header avec accent */}
        <div className="bg-gradient-primary px-6 py-4 relative">
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-2 right-2 text-primary-foreground/80 hover:text-primary-foreground hover:bg-transparent"
            onClick={handleClose}
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </Button>

          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
              <Gift className="w-6 h-6 text-primary-foreground" />
            </div>
            <div>
              <h2
                id="newsletter-popup-title"
                className="font-cinzel font-semibold text-primary-foreground text-lg"
              >
                Un cadeau pour vous
              </h2>
              <p className="text-primary-foreground/80 text-sm font-montserrat">
                Inscrivez-vous et recevez votre guide gratuit
              </p>
            </div>
          </div>
        </div>

        {/* Contenu */}
        <div className="p-6">
          <NewsletterForm
            variant="compact"
            showTitle={false}
            showDescription={true}
          />
        </div>

        {/* Footer discret */}
        <div className="px-6 pb-4 text-center">
          <button
            onClick={handleClose}
            className="text-xs text-muted-foreground hover:text-foreground font-montserrat underline underline-offset-2"
          >
            Non merci, peut-être plus tard
          </button>
        </div>
      </div>
    </>
  );
};
